<template>
  <v-row :class="tp.partClass"
    @mouseover="hover = true"
    @mouseout="hover = false">
    <template>
      <v-tooltip top v-for="(dpa, dpai) in dp.attrs" :key="dpa.dpa_id" :disabled="!dp.details || hideCompareVersion">
        <template v-slot:activator="{ on, attrs }">
          <v-col class="pa-0" :cols="dpa.cols || 12" v-bind="attrs" v-on="on">
            <template v-if="dpai === dp.attrs.length - 1">
              <div class="float-right ml-1"         
                v-if="commentActions?.length"
              >
                <v-badge
                  v-if="showResolving && dp.comments_unresolved"
                  color="green"
                  :content="dp.comments_unresolved"
                >
                  <v-icon
                    style="font-size: 20px; color: #7d93b4 !important"
                    title="Show comments"
                    @click="$emit('showComments', dp)"
                    >mdi-message-outline
                  </v-icon>
                </v-badge>
                <v-icon
                  v-else-if="dp.hasComments"
                  style="font-size: 20px; color: #7d93b4 !important"
                  title="Show comments"
                  @click="$emit('showComments', dp)"
                  >mdi-message-outline
                </v-icon>
                <v-icon
                  v-else-if="commentActions.some(c => c.isComment)"
                  style="font-size: 20px; color: #7d93b4 !important"
                  :style="!hover ? 'visibility: hidden;' : ''"
                  title="Add comment"
                  @click="$emit('showComments', dp)"
                  >mdi-message-outline
                </v-icon>
              </div>
              <v-chip v-if="
                highlightChanges && dp.essential_changes
                  ? dp.essential_changes
                  : dp.essential
              " small class="float-right mb-1">
                <span v-html="highlightChanges && dp.essential_changes
                  ? dp.essential_changes
                  : dp.essential
                  "></span>
              </v-chip>
            </template>
            <template>
              <span v-if="
                highlightChanges && dpa.changes
                  ? dpa.changes
                  : dpa.text
              " v-html="highlightChanges && dpa.changes
                ? dpa.changes
                : dpa.text
                " :class="{
                    ListPart:
                      dpai === 0 &&
                      (tp.moveable || dp.type === 'listitem'),
                  }"></span></template>
          </v-col>
        </template>
        <span>{{ dp.details }}</span>
      </v-tooltip>
      <!-- <div class="viewPartRowActions"> -->
      <!-- </div> -->
    </template>
    <v-col cols="12" v-if="dp.childParts && dp.childParts.length">
      <DocumentVersionComparePart class="childPart" 
        v-for="cdp in dp.childParts" :key="cdp.dp_id" 
        :dp="cdp" 
        :commentActions="commentActions" 
        :tp="tp.childParts.find(ctp => cdp.tp_id === ctp.tp_id)"
        :hideCompareVersion="hideCompareVersion" 
        :highlightChanges="highlightChanges"
        @showComments="$emit('showComments', cdp)">
      </DocumentVersionComparePart>
    </v-col>
  </v-row>
</template>

<script>
// import DocumentVersionComparePart from "@/components/audit/cDocumentVersionComparePart";
import { mapState } from "vuex";

export default {
  name: "DocumentVersionComparePart",
  components: {
    // DocumentVersionComparePart,
  },
  props: {
    dp: { type: Object, required: true },
    tp: { type: Object, required: true },
    hideCompareVersion: { type: Boolean, default: false },
    highlightChanges: { type: Boolean, default: true },
    commentActions: [],
    partCommentUpdate: Object,
  },
  data: function () {
    return {
      hover: false,
    };
  },
  updated() { },
  mounted() { },
  computed: {
    ...mapState({
      config: (state) => state.settings.config,
    }),
    showResolving(){
      return this.config.settings.some(
          (s) => s.setting === 'document_comments_resolve' && s.value === "true"
      );
    },   
  },
  watch: {
    // partCommentUpdate(val) {
    //   if (val) this.updatePartComment(val);
    // },
  },
  methods: {    
    // updatePartComment(part) {
    //   let dp = viewUtils.findPart(this.docParts, part.dp_id);
    //   dp.comments_unresolved = part.comments_unresolved;
    //   dp.comments_total = part.comments_total;
    //   dp.hasComments = part.hasComments;
    // },
  }
};
</script>
<style scoped lang="scss">
.HeaderPart,
.CentralHeaderPart {
  font-weight: 700;
  font-size: 18px;
}

.CentralTitle,
.Title {
  font-size: 1.625rem;
  font-weight: bold;
  line-height: 1.6;
}

.DocumentHdr {
  font-size: 1.25rem;
  font-style: italic;
}

.CentralHeaderPart,
.CentralTitle {
  text-align: center;
}

.AttrHeaderPart {
  font-weight: bold;
  font-size: 1rem;
  line-height: normal;
}

.ListPart {
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;
}

.childPart {
  margin-left: 20px;
}
</style>
